import { useFlag } from '@calendly/feature-check-react'

import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'
import { useTrack } from 'hooks/analytics_events/useTrack'

const trackV2Hits = {}

const checkHit = (key) => {
  if (trackV2Hits[key]) { return true }

  trackV2Hits[key] = true

  return false
}

// This is called after useMeetingIntelligenceFeatureFlag because it sends the event to Segment
export const trackMiV2 = (track) => {
  const flagKey = 'meeting_intelligence'

  if (!checkHit(flagKey)) {
    track({
      name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
      properties: {
        flag_key: 'meeting_intelligence',
        rule: 'targeted_delivery',
        source: 'frontend',
        variation_key: 'on'
      }
    })
  }
}

export const useMeetingIntelligenceFeatureFlag = () => {
  const isMiEnabled = useFlag('meeting_intelligence')
  const track = useTrack()

  if (isMiEnabled) {
    trackMiV2(track)
  }

  return isMiEnabled
}
